import { Toast } from '@skbkontur/react-ui';
// https://tech.skbkontur.ru/react-ui/#/Components/Toast
// задержка 7 секунд совпадает с длительностью показа Toast
const ACTION_DELAY = 7 * 1000;
export const showToastWithDelayedAction = (params) => {
    let completed = false;
    window.addEventListener('beforeunload', params.onDelay);
    const timeoutId = window.setTimeout(() => {
        completed = true;
        Toast.close();
        params.onDelay();
        window.removeEventListener('beforeunload', params.onDelay);
    }, ACTION_DELAY);
    const cancelHandler = () => {
        completed = true;
        Toast.close();
        params.onCancel();
        window.clearTimeout(timeoutId);
        window.removeEventListener('beforeunload', params.onDelay);
    };
    Toast.push(params.message, {
        label: params.cancelLabel || 'Отменить',
        handler: cancelHandler,
    });
    return async () => {
        if (completed) {
            return;
        }
        window.clearTimeout(timeoutId);
        Toast.close();
        await params.onDelay();
        window.removeEventListener('beforeunload', params.onDelay);
    };
};
